/* Publish by EComposer at 2026-09-29 18:39:51*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-odtg4kijpo"]=  window.__ectimmers["ecom-odtg4kijpo"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-odtg4kijpo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-odtg4kijpo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iog0mfc69b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iog0mfc69b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ohmdhzjoyp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ohmdhzjoyp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-96r8o50le7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-96r8o50le7a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bukkk2un8mj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bukkk2un8mj', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uljb0bvh59"]=  window.__ectimmers["ecom-uljb0bvh59"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-uljb0bvh59"]["kqbhhl7qr"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-uljb0bvh59').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uljb0bvh59', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wz66g89zjl"]=  window.__ectimmers["ecom-wz66g89zjl"] || {};
if(!this.$el||!window.EComModal)return;const t=this.isLive;let e=this.$el.querySelectorAll("[ecom-modal]");e.length&&t&&new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-wz66g89zjl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wz66g89zjl', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-l6k335qqzu"]=  window.__ectimmers["ecom-l6k335qqzu"] || {};
var e=this.$el;if(e&&this.isLive){var t=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");t.length&&t.forEach(function(i){var a=i.getAttribute("href")||"#",r=a.replace("{current-link}",location.href);i.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-l6k335qqzu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l6k335qqzu', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lry4pefx8dp"]=  window.__ectimmers["ecom-lry4pefx8dp"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-lry4pefx8dp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lry4pefx8dp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xfouylhri99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xfouylhri99', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-41s1q0gm1l4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-41s1q0gm1l4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mvgtqd1so6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mvgtqd1so6', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9v02zvtzns5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9v02zvtzns5', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-34agqsil8ck').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-34agqsil8ck', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}